module.exports = __webpack_public_path__ + "static/img/peoplactive.1c6660db.png";